module.exports = __webpack_public_path__ + "static/media/patente-8.aa673ed4.png";